import { motion } from 'framer-motion';
import { 
  ShoppingCart, Stethoscope, Landmark, Car, GraduationCap, Plane, Utensils, Home, 
  Scale, Briefcase, Factory, Heart, Leaf, Music, Camera, Dumbbell, Palette, Wifi, 
  Shield, Baby, Dog, Shirt, Gem, Wrench, Truck, Coffee, Scissors, BookOpen, Smartphone, Building2
} from 'lucide-react';
import { useLang } from '../../../context/LangContext';

const useCases = [
  { icon: ShoppingCart, nameFr: "E-commerce", nameEn: "E-commerce", caseFr: "Suivi commandes 24/7", caseEn: "24/7 order tracking", color: "#54A133" },
  { icon: Stethoscope, nameFr: "Santé", nameEn: "Healthcare", caseFr: "Prise de RDV automatisée", caseEn: "Automated appointments", color: "#5399C2" },
  { icon: Landmark, nameFr: "Banque", nameEn: "Banking", caseFr: "Qualification de leads", caseEn: "Lead qualification", color: "#E0C568" },
  { icon: Car, nameFr: "Automobile", nameEn: "Automotive", caseFr: "Devis instantanés", caseEn: "Instant quotes", color: "#54A133" },
  { icon: GraduationCap, nameFr: "Éducation", nameEn: "Education", caseFr: "Inscription en ligne", caseEn: "Online enrollment", color: "#5399C2" },
  { icon: Plane, nameFr: "Tourisme", nameEn: "Tourism", caseFr: "Réservation vocale", caseEn: "Voice booking", color: "#E0C568" },
  { icon: Utensils, nameFr: "Restauration", nameEn: "Restaurant", caseFr: "Commande par téléphone", caseEn: "Phone ordering", color: "#54A133" },
  { icon: Home, nameFr: "Immobilier", nameEn: "Real Estate", caseFr: "Visites planifiées", caseEn: "Scheduled visits", color: "#5399C2" },
  { icon: Scale, nameFr: "Juridique", nameEn: "Legal", caseFr: "Pré-qualification client", caseEn: "Client pre-qualification", color: "#E0C568" },
  { icon: Briefcase, nameFr: "Consulting", nameEn: "Consulting", caseFr: "Prise de brief automatisée", caseEn: "Automated briefing", color: "#54A133" },
  { icon: Factory, nameFr: "Industrie", nameEn: "Manufacturing", caseFr: "Support technique 24/7", caseEn: "24/7 tech support", color: "#5399C2" },
  { icon: Shield, nameFr: "Assurance", nameEn: "Insurance", caseFr: "Déclaration de sinistres", caseEn: "Claims reporting", color: "#E0C568" },
  { icon: Heart, nameFr: "ONG", nameEn: "NGO", caseFr: "Gestion des dons", caseEn: "Donation management", color: "#54A133" },
  { icon: Leaf, nameFr: "Agriculture", nameEn: "Agriculture", caseFr: "Conseil technique", caseEn: "Technical advice", color: "#5399C2" },
  { icon: Music, nameFr: "Divertissement", nameEn: "Entertainment", caseFr: "Billetterie vocale", caseEn: "Voice ticketing", color: "#E0C568" },
  { icon: Camera, nameFr: "Photographie", nameEn: "Photography", caseFr: "Réservation de séances", caseEn: "Session booking", color: "#54A133" },
  { icon: Dumbbell, nameFr: "Fitness", nameEn: "Fitness", caseFr: "Planning cours", caseEn: "Class scheduling", color: "#5399C2" },
  { icon: Palette, nameFr: "Art & Design", nameEn: "Art & Design", caseFr: "Demande de devis", caseEn: "Quote requests", color: "#E0C568" },
  { icon: Wifi, nameFr: "Télécom", nameEn: "Telecom", caseFr: "Support technique", caseEn: "Tech support", color: "#54A133" },
  { icon: Building2, nameFr: "Sécurité", nameEn: "Security", caseFr: "Demande d'intervention", caseEn: "Intervention requests", color: "#5399C2" },
  { icon: Baby, nameFr: "Petite Enfance", nameEn: "Childcare", caseFr: "Inscription crèche", caseEn: "Daycare enrollment", color: "#E0C568" },
  { icon: Dog, nameFr: "Animalerie", nameEn: "Pet Services", caseFr: "RDV vétérinaire", caseEn: "Vet appointments", color: "#54A133" },
  { icon: Shirt, nameFr: "Mode", nameEn: "Fashion", caseFr: "Conseil personnalisé", caseEn: "Personal styling", color: "#5399C2" },
  { icon: Gem, nameFr: "Luxe", nameEn: "Luxury", caseFr: "Service VIP", caseEn: "VIP service", color: "#E0C568" },
  { icon: Wrench, nameFr: "Services Tech", nameEn: "Tech Services", caseFr: "Dépannage urgent", caseEn: "Emergency repairs", color: "#54A133" },
  { icon: Truck, nameFr: "Logistique", nameEn: "Logistics", caseFr: "Suivi livraison", caseEn: "Delivery tracking", color: "#5399C2" },
  { icon: Coffee, nameFr: "Hôtellerie", nameEn: "Hospitality", caseFr: "Réservation vocale", caseEn: "Voice reservations", color: "#E0C568" },
  { icon: Scissors, nameFr: "Beauté", nameEn: "Beauty", caseFr: "Prise de RDV salon", caseEn: "Salon appointments", color: "#54A133" },
  { icon: BookOpen, nameFr: "Média", nameEn: "Media", caseFr: "Abonnements", caseEn: "Subscriptions", color: "#5399C2" },
  { icon: Smartphone, nameFr: "Tech & Startups", nameEn: "Tech & Startups", caseFr: "Onboarding client", caseEn: "Client onboarding", color: "#E0C568" },
];

export const UseCasesCarousel = () => {
  const { lang } = useLang();

  // Double the array for seamless infinite scroll
  const doubledCases = [...useCases, ...useCases];

  return (
    <section data-testid="use-cases-carousel" className="py-20 bg-[#020209] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 mb-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight mb-4">
            {lang === 'fr' ? '30 cas d\'usage concrets' : '30 concrete use cases'}
          </h2>
          <p className="text-neutral-400 text-lg max-w-2xl mx-auto">
            {lang === 'fr' 
              ? 'Une solution adaptée à chaque secteur, chaque besoin, chaque entreprise.'
              : 'A solution adapted to every sector, every need, every business.'}
          </p>
        </motion.div>
      </div>

      {/* First row - scroll right */}
      <div className="relative mb-4">
        <motion.div
          className="flex gap-4"
          animate={{
            x: [0, -50 * useCases.length],
          }}
          transition={{
            x: {
              duration: 40,
              repeat: Infinity,
              ease: "linear",
            },
          }}
        >
          {doubledCases.map((useCase, index) => {
            const Icon = useCase.icon;
            return (
              <div
                key={`row1-${index}`}
                className="flex-shrink-0 w-[280px] p-5 rounded-2xl bg-white/[0.02] border border-white/[0.05] hover:border-white/[0.15] hover:bg-white/[0.04] transition-all duration-300"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div 
                    className="w-10 h-10 rounded-lg flex items-center justify-center"
                    style={{ backgroundColor: `${useCase.color}15` }}
                  >
                    <Icon size={20} style={{ color: useCase.color }} />
                  </div>
                  <span className="text-white font-medium">
                    {lang === 'fr' ? useCase.nameFr : useCase.nameEn}
                  </span>
                </div>
                <p className="text-sm text-neutral-400">
                  {lang === 'fr' ? useCase.caseFr : useCase.caseEn}
                </p>
              </div>
            );
          })}
        </motion.div>
      </div>

      {/* Second row - scroll left */}
      <div className="relative">
        <motion.div
          className="flex gap-4"
          animate={{
            x: [-50 * useCases.length, 0],
          }}
          transition={{
            x: {
              duration: 45,
              repeat: Infinity,
              ease: "linear",
            },
          }}
        >
          {[...doubledCases].reverse().map((useCase, index) => {
            const Icon = useCase.icon;
            return (
              <div
                key={`row2-${index}`}
                className="flex-shrink-0 w-[280px] p-5 rounded-2xl bg-white/[0.02] border border-white/[0.05] hover:border-white/[0.15] hover:bg-white/[0.04] transition-all duration-300"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div 
                    className="w-10 h-10 rounded-lg flex items-center justify-center"
                    style={{ backgroundColor: `${useCase.color}15` }}
                  >
                    <Icon size={20} style={{ color: useCase.color }} />
                  </div>
                  <span className="text-white font-medium">
                    {lang === 'fr' ? useCase.nameFr : useCase.nameEn}
                  </span>
                </div>
                <p className="text-sm text-neutral-400">
                  {lang === 'fr' ? useCase.caseFr : useCase.caseEn}
                </p>
              </div>
            );
          })}
        </motion.div>
      </div>

      {/* Count badge */}
      <motion.div
        className="text-center mt-12"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        <span className="inline-flex items-center px-6 py-3 rounded-full border border-brand-green/30 bg-brand-green/10 text-brand-green font-medium">
          {lang === 'fr' ? '30+ secteurs couverts' : '30+ sectors covered'}
        </span>
      </motion.div>
    </section>
  );
};
